import type { FormikErrors } from "formik"
import React, { createContext } from "react"

import { IAddress } from "models"

import type { AddressVerificationInfo } from "../hooks"

interface SmartyAddressVerificationContextProps {
  isOverlayVisible: boolean
  showAutoCompleteOverlay: () => void
  hideAutoCompleteOverlay: () => void
  addressVerificationInfo?: AddressVerificationInfo
  updateAddressVerificationInfo: React.Dispatch<React.SetStateAction<AddressVerificationInfo | undefined>>
  autoCompleteRecommendedAddress?: (
    setFieldValue: (field: string, value: unknown, shouldValidate?: boolean) => Promise<void | FormikErrors<IAddress>>,
    parentFieldName?: string,
  ) => void
  bypassAddressValidation?: () => void
}

const SmartyAddressVerificationContext = createContext<SmartyAddressVerificationContextProps | undefined>(undefined)
SmartyAddressVerificationContext.displayName = "SmartyAddressVerificationContext"

export { SmartyAddressVerificationContext }
